<link [href]="brandingCss" rel="stylesheet">

<div id="ifa-calc-header-background" class="ifa-calc-background">
  <div #confettiCanvas></div>
</div>

<div class="ifa-calc-wrapper" fxLayout="column" *ngIf="offerPageScreen === OfferPageScreen.FullOffer">

  <div fxLayout="column" fxLayoutAlign="start center">

    <h2>
      Congratulations!
    </h2>

    <h4 class="layout padding-left padding-right">
      {{application?.businessName}} has offers for financing up to<span *ngIf="bundles?.length" class="highlighted"> {{maxOfferAmount | currency:'$'}}</span> 
      and terms up to<span *ngIf="bundles?.length" class="highlighted"> {{maxRepaymentLabel}}</span>. See your approved product(s) below. 
    </h4>

    <ifa-share-offer *ngIf="!isPreview" [emailBody]="shareOfferEmailBody" class="share-offer-centered"></ifa-share-offer>

    <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="24px" fxLayout.lt-lg="column"
      fxLayoutAlign.lt-lg="center center" class="layout padding-top">
      <ifa-summary-offer-widget *ngFor="let bundle of bundles" [bundle]="bundle" [offerBundles]="application?.offerBundles" [uuid]="application?.uuid"
        [largeLoanProgramOffered]="largeLoanProgramOffered"></ifa-summary-offer-widget>
    </div>

    <ifa-link-your-bank [applicationUuid]="uuid" [bankLinkStatus]="application?.bankLinkStatus" ></ifa-link-your-bank>

    <p class="layout padding-left padding-right" *ngIf="!isPreview">
      Call or email
      {{application?.advisorName}} at <a href="tel:{{application?.advisorPhone}}">{{application?.advisorPhone}}</a> or
      <a href="mailto:{{application?.advisorEmail}}">{{application?.advisorEmail}}</a> and let them know which offer you have selected.
    </p>

  </div>

</div>

<ifa-offer-page-status-message *ngIf="offerPageScreen && offerPageScreen !== OfferPageScreen.FullOffer"
                              [screen]="offerPageScreen"
                              [application]="application"></ifa-offer-page-status-message>
